import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import ChangeProfilePage, { getDefaultPageUI } from "components/pages/ChangeProfilePage";
import Classes from "model";

/**
 * @function CaptureMobileHeaderFooter
 * @param {Void} - No arguments are passed.
 * @returns {React.Component}
 * @description This component is for ZLE captures where
 * only the ABI22 header and MABI23 footer are shown. 
 * The page body is removed.
 */
export default function CaptureMobileHeaderFooter(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ "hidePageBody" ], true)
    .submit();

    return <ChangeProfilePage ui={ ui }/>;
}